import React from 'react';
import styles from './busType.module.css';
import Slider from './slider';

/* 파일명이 그대로라 옛 사진이 캐시에 남는다 → ?v 로 새 URL 을 만든다 */
const busImages = [
  { url: '/image/bigBus/interior1.jpg?v=2' },
  { url: '/image/bigBus/interior2.jpg?v=2' },
  { url: '/image/bigBus/interior3.jpg?v=2' },
  { url: '/image/bigBus/interior4.jpg?v=2' },
];

const BigBus = () => {
  return (
      <section className={styles.container}>
        <h1 className={styles.title}>45인승 대형</h1>

        <section>
          <p className={styles.busDetail}>
            가장 일반적으로 많이 애용되는 전세버스입니다. <br />
            40~45인승의 단체 여행에 적합하고 기업체, 관공서, 동호회, 일반단체의 국내 버스여행에 <br />
            많이 이용되며 기업체와 관공서 출퇴근 차량, 대학생 MT, OT, 외국인 투어에도 많이 이용됩니다.
          </p>
          <img
            className={styles.exteriorPhoto}
            src='/image/bigBusExterior.jpg?v=2'
            alt='45인승 대형버스 외관'
          />
          <h2 className={styles.imageTitle}>차량 사진</h2>
          <Slider imageList={busImages} />
        </section>
      </section>
  )
};

export default BigBus;